import React from "react";

export function BgSvg() {
  return (
    <>
      <div className="absolute top-8 left-4">
        <svg
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full md:w-[983px]"
          height="6"
          fill="none"
          viewBox="0 0 983 6"
        >
          <path
            stroke="url(#paint0_linear_751_11584)"
            strokeWidth="2.91"
            d="M982.66 2H6a4 4 0 00-4 4v0"
          ></path>
          <defs>
            <linearGradient
              id="paint0_linear_751_11584"
              x1="129"
              x2="129.305"
              y1="3.785"
              y2="18.428"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#043D4A" stopOpacity="0"></stop>
              <stop offset="0.292" stopColor="#03482B"></stop>
              <stop offset="0.573" stopColor="#052784"></stop>
              <stop offset="0.979" stopColor="#052784" stopOpacity="0"></stop>
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div className="absolute bottom-8 -left-40">
        <svg
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full md:w-[983px]"
          height="6"
          fill="none"
          viewBox="0 0 983 6"
        >
          <path
            stroke="url(#paint0_linear_751_11584)"
            strokeWidth="2.91"
            d="M982.66 2H6a4 4 0 00-4 4v0"
          ></path>
          <defs>
            <linearGradient
              id="paint0_linear_751_11584"
              x1="129"
              x2="129.305"
              y1="3.785"
              y2="18.428"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#043D4A" stopOpacity="0"></stop>
              <stop offset="0.292" stopColor="#03482B"></stop>
              <stop offset="0.573" stopColor="#052784"></stop>
              <stop offset="0.979" stopColor="#052784" stopOpacity="0"></stop>
            </linearGradient>
          </defs>
        </svg>
      </div>
    </>
  );
}
